import { apiRequest } from "./http";

export interface DashboardPayment {
    payment_id: string;
    date: string;
    status: string;
    price: number;
}

export interface DashboardSubscription {
    id: number;
    user_id: number;
    plan_name: string;
    price: number;
    status: string;
    payment_status: string;
    payment_reference: string;
    starts_at: string;
    ends_at: string;
    created_at: string;
    updated_at: string;
    cancelled_at: string | null;
}

export interface DashboardUserMeta {
    phone?: number;
    role?: string;
    display_name?: string;
}

export interface DashboardData {
    firstname: string;
    lastname: string;
    email: string;
    user_meta?: DashboardUserMeta;
    payments: DashboardPayment[];
    subscriptions: DashboardSubscription[];
}

export interface DashboardResponse {
    success: boolean;
    message: string;
    data: DashboardData;
}

export interface UpdateProfilePayload {
    firstname: string;
    lastname: string;
    display_name: string;
}

export interface UpdateProfileResponse {
    success: boolean;
    message: string;
    data?: {
        firstname?: string;
        lastname?: string;
        user_meta?: {
            display_name?: string;
        };
    };
}

export function getUserDashboard(token: string) {
    return apiRequest<DashboardResponse>({
        endpoint: "/user/dashboard",
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function updateUserProfile(token: string, payload: UpdateProfilePayload) {
    return apiRequest<UpdateProfileResponse>({
        endpoint: "/user/profile",
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
}

export interface ChangePasswordPayload {
    old_password?: string;
    new_password: string;
}

export interface ChangePasswordResponse {
    success: boolean;
    message: string;
}

export function changeUserPassword(token: string, payload: ChangePasswordPayload) {
    return apiRequest<ChangePasswordResponse>({
        endpoint: "/auth/change-password",
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
}
